import { render, staticRenderFns } from "./pass-firm.vue?vue&type=template&id=21dcda37&scoped=true"
import script from "./pass-firm.vue?vue&type=script&lang=js"
export * from "./pass-firm.vue?vue&type=script&lang=js"
import style0 from "./pass-firm.vue?vue&type=style&index=0&id=21dcda37&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dcda37",
  null
  
)

export default component.exports